module.exports = __webpack_public_path__ + "img/catalog-f.935461a4.svg";